const wrapRootElement = require('./wrap-root-element').default

exports.wrapRootElement = wrapRootElement
